module.exports = __webpack_public_path__ + "img/whatsapp.3a2e460e.svg";